import { ReactComponent as ThumbsDown } from 'assets/images/videoReactions/thumbsDown.svg';
import styled from 'styled-components/macro';

const ThumbsDownIcon = styled(ThumbsDown)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default ThumbsDownIcon;
